import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import { useMemo } from "react";
import { useSingleSupportTicketData } from "./use-support-ticket-data";

export function useSupportTicketView(supportTicketId: SupportTicketId) {
  const { supportTicket, threads, messages, isLoading } =
    useSingleSupportTicketData(supportTicketId);

  const customerName = supportTicket?.customer?.displayName ?? "Customer";

  const latestMessageTime = useMemo(() => {
    if (messages.length === 0) {
      return null;
    }
    const latestMessage = messages[messages.length - 1];
    return latestMessage ? latestMessage.sentAt : null;
  }, [messages]);

  return {
    supportTicket,
    threads,
    messages,
    isLoading,
    customerName,
    latestMessageTime,
  };
}
